import { ProjectService } from './../../service/project.service';
import { UserService } from './../../service/user.service';
import {
  APP_SHELL_MOBILE_MAX_WIDTH,
  SidebarStateService,
} from '../../service/sidebar-state.service';
import { Component, inject, HostListener, OnInit, AfterViewInit, OnDestroy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { SharedModule, team } from '../../shared/shared.module';
import { RouterLink, RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { TeamImaginusNavService } from '../../service/team-imaginus-nav.service';
import {
  ChatConversation,
  ChatConversationService,
} from '../../service/chat-conversation.service';
import { ImaginusService } from '../../service/imaginus.service';
import { GroupService } from '../../service/group.service';
import { TeamService } from '../../service/team.service';
import { FavoriteAppsService, FavoriteAppLink } from '../../service/favorite-apps.service';
import { UserPreferencesService } from '../../service/user-preferences.service';
import { LocaleService } from '../../service/locale.service';
import { TranslateModule } from '@ngx-translate/core';
import {
  IMAGINUS_UNIFIED_PIN_KEY,
  ImaginusNavSession,
  imaginusSessionNavKey,
  imaginusSessionQueryParams,
} from '../../service/imaginus-unified-session.model';
import { Subscription } from 'rxjs';
import { NgScrollbar } from 'ngx-scrollbar';
import { CommonModule } from '@angular/common';
import {
  ContainerComponent,
  ColorModeService,
  ShadowOnScrollDirective,
  SidebarBrandComponent,
  SidebarComponent,
  SidebarNavComponent,
  SidebarToggleDirective,
  SidebarTogglerDirective,
  ModalModule,
  CardModule,
  GridModule,
  ButtonModule,
  SpinnerComponent,
  FormControlDirective,
  FormLabelDirective,
} from '@coreui/angular';
import { DefaultFooterComponent, DefaultHeaderComponent } from './';
import { navItems } from './_nav';
import { user } from '../../shared/shared.module';
import { IconDirective } from '@coreui/icons-angular';
import { ImaginusSessionSearchComponent } from '../imaginus-session-search/imaginus-session-search.component';
import { HelpArticleLinkComponent } from '../../shared/help-article-link.component';
import { HELP_ARTICLES } from '../../shared/help-article-ids';

import { TokenStorageService } from '@services/token-storage.service';
import {
  cilMenu, cilPlus, cilApps, cilTerminal, cilZoom, cilLightbulb, cilChartLine, cilChatBubble, cilPuzzle, cilSettings, cilCompass, cilCalendarCheck,
  cilOptions, cilPin, cilPencil, cilTrash, cilStar, cilArrowRight, cilMoney, cilEnvelopeClosed, cilUser, cilGroup
} from '@coreui/icons';

interface AppChild {
  name: string;
  url: string;
  icon?: string;
}

interface AppItem {
  id: number;
  name: string;
  description: string;
  url: string;
  icon: string;
  children?: AppChild[];
  roles?: string[];
}

@Component({
  selector: 'app-layout',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss'],
  standalone: true,
  imports: [
    SidebarComponent,
    SidebarBrandComponent,
    SidebarNavComponent,
    SidebarToggleDirective,
    SidebarTogglerDirective,
    SharedModule,
    RouterLink,
    NgScrollbar,
    DefaultHeaderComponent,
    ShadowOnScrollDirective,
    ContainerComponent,
    RouterOutlet,
    DefaultFooterComponent,
    CommonModule,
    IconDirective,
    ModalModule,
    CardModule,
    GridModule,
    ButtonModule,
    ImaginusSessionSearchComponent,
    SpinnerComponent,
    FormControlDirective,
    FormLabelDirective,
    TranslateModule,
    HelpArticleLinkComponent,
  ]
})
export class DefaultLayoutComponent implements OnInit, AfterViewInit, OnDestroy {
  readonly help = HELP_ARTICLES;
  @ViewChild('sidebar1') private sidebarRef?: SidebarComponent;
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly locale = inject(LocaleService);
  private langSub?: Subscription;

  public navItems = [...navItems];
  /** 與 CoreUI / Imaginus 主區 @media (max-width: 991.98px) 一致 */
  public isMobile = window.innerWidth <= APP_SHELL_MOBILE_MAX_WIDTH;

  public sidebarVisible = !this.isMobile;
  public sidebarUnfoldable = false;
  /**
   * 側欄旁 Kebab／觸控選單；快取於欄位，避免 getters + matchMedia
   * 在 dev CD 雙重檢查時不一致而觸發 NG0100。
   */
  showSessionMenuDropdown = true;
  useSessionTouchSheet = false;
  /** 未讀點：欄位快取，避免 getter 在同一輪 CD 中由 false→true */
  hasChatUnread = false;
  public appModalVisible = false;
  public personalAppList: AppItem[] = [];
  /** 個人工作區連結（不分群組卡片，扁平列表） */
  personalAppLinks: AppChild[] = [];
  public teamAppList: AppItem[] = [];
  readonly isDesktopShell: boolean;
  isImaginusPage = false;
  /** 頂欄浮動覆蓋時，主內容全高（/home、場域聊天室等） */
  isContentBleed = false;

  readonly unifiedPinKey = IMAGINUS_UNIFIED_PIN_KEY;
  imaginusList: ImaginusNavSession[] = [];
  favoriteApps: FavoriteAppLink[] = [];
  personalAvatarUrl = '';
  teamAvatarUrls: Record<string, string> = {};
  sessionMenuPopperOptions: Record<string, unknown> = {
    placement: 'right-start',
    strategy: 'absolute',
  };
  private sessionLpt: ReturnType<typeof setTimeout> | null = null;
  private suppressNextSessionLink = false;
  sessionActionSheetOpen = false;
  sessionActionTarget: ImaginusNavSession | null = null;
  private imaginusNavSub?: Subscription;
  private imaginusRouteSub?: Subscription;
  private sidebarToggleRequestSub?: Subscription;
  private favoriteAppsSub?: Subscription;
  private personalAvatarSub?: Subscription;
  private selectedTeamPrefSub?: Subscription;
  private previousNavUrl = '';
  private teamAppsFetchSeq = 0;

  team_list: team[] = [];
  /** 已申請加入、待團隊管理員審核（後端 pending_teams） */
  pending_team_list: team[] = [];
  selectedTeamCodeForApps = '';
  /** 與 teamAppList 對應，避免下拉已換團隊但列表仍顯示上一團隊應用 */
  teamAppsLoadedForCode = '';
  /**
   * 原生 select 在 option 列表被重建時會把畫面重置成第一個選項，
   * 但 ngModel 仍是目前團隊。透過 remount 強制重新綁定顯示值。
   */
  teamAppsSelectMounted = true;
  activeRouteTeamCode = '';
  newTeamName = '';
  isCreatingTeam = false;
  /** 在「群組與應用」團隊分頁內以行內表單建立團隊，避免巢狀 modal 殘留 backdrop。 */
  showInlineCreateTeam = false;
  /** 在「群組與應用」團隊分頁內以行內表單申請加入團隊。 */
  showInlineJoinTeam = false;
  joinTeamCode = '';
  isApplyingJoinTeam = false;
  /** 建立團隊成功提示 */
  createTeamToast: string | null = null;
  private createTeamToastTimer: ReturnType<typeof setTimeout> | null = null;

  user!: user;
  readonly #colorModeService = inject(ColorModeService);
  readonly colorMode = this.#colorModeService.colorMode;

  icons = { cilMenu, cilPlus, cilApps, cilTerminal, cilZoom, cilLightbulb, cilChartLine, cilChatBubble, cilPuzzle, cilSettings, cilCompass, cilCalendarCheck, cilOptions, cilPin, cilPencil, cilTrash, cilStar, cilArrowRight, cilMoney, cilEnvelopeClosed, cilUser, cilGroup };

  /** 聊天模式：左側 nav 顯示聊天室清單（場域聊天室 + 私訊） */
  chatConversations: ChatConversation[] = [];
  private chatConversationsSub?: Subscription;

  private readonly teamAppsCatalogTemplate: Array<{
    id: number;
    nameKey: string;
    descKey: string;
    url: string;
    icon: string;
    children: Array<{ nameKey: string; url: string }>;
  }> = [
    {
      id: 1,
      nameKey: 'layout.apps.energyProject.name',
      descKey: 'layout.apps.energyProject.desc',
      url: '/team/:team_code/application/1',
      icon: 'cilLightbulb',
      children: [
        { nameKey: 'layout.apps.energyProject.findProject', url: '/team/:team_code/application/1/find' },
        { nameKey: 'layout.apps.energyProject.myPlaces', url: '/team/:team_code/application/1/places' },
        { nameKey: 'layout.apps.energyProject.management', url: '/team/:team_code/application/1/management' },
      ],
    },
    {
      id: 2,
      nameKey: 'layout.apps.energyService.name',
      descKey: 'layout.apps.energyService.desc',
      url: '/team/:team_code/application/2',
      icon: 'cilChartLine',
      children: [
        { nameKey: 'layout.apps.energyService.findProvider', url: '/team/:team_code/application/2/find' },
        { nameKey: 'layout.apps.energyService.myPlaces', url: '/team/:team_code/application/2/places' },
        { nameKey: 'layout.apps.energyService.performance', url: '/team/:team_code/application/2/management' },
      ],
    },
    {
      id: 4,
      nameKey: 'layout.apps.energyEngineering.name',
      descKey: 'layout.apps.energyEngineering.desc',
      url: '/team/:team_code/application/4',
      icon: 'cilPuzzle',
      children: [
        { nameKey: 'layout.apps.energyEngineering.findProject', url: '/team/:team_code/application/4/find' },
        { nameKey: 'layout.apps.energyEngineering.myProjects', url: '/team/:team_code/application/4/project' },
        { nameKey: 'layout.apps.energyEngineering.support', url: '/team/:team_code/application/4/support' },
      ],
    },
  ];
  private teamAppsActivatedIds: number[] = [];

  constructor(
    private userService: UserService,
    private ProjectService: ProjectService,
    private router: Router,
    public sidebarState: SidebarStateService,
    public teamImaginusNav: TeamImaginusNavService,
    private imaginusService: ImaginusService,
    private groupService: GroupService,
    private teamService: TeamService,
    public favoriteAppsService: FavoriteAppsService,
    private userPreferencesService: UserPreferencesService,
    public chatConversationService: ChatConversationService,
  ) {
    const qsDesktop =
      typeof window !== 'undefined' &&
      new URLSearchParams(window.location.search).get('desktop_shell') === '1';
    if (qsDesktop && typeof localStorage !== 'undefined') {
      localStorage.setItem('ima_desktop_shell', '1');
    }
    const cachedDesktop =
      typeof localStorage !== 'undefined' &&
      localStorage.getItem('ima_desktop_shell') === '1';
    this.isDesktopShell =
      qsDesktop ||
      cachedDesktop ||
      (typeof navigator !== 'undefined' &&
        navigator.userAgent.toLowerCase().includes('imaonedesktopshell'));
    this.get_self_info();
    this.loadUserTeams();
  }

  ngOnInit(): void {
    this.checkMobile();
    this.updateSessionUiHints();
    this.syncImaginusPage(this.router.url);
    this.syncRouteTeamCode(this.router.url);
    this.chatNavMode = this.isChatsUrl(this.router.url);
    this.favoriteApps = this.favoriteAppsService.getSnapshot();
    this.personalAvatarUrl =
      this.userService.profile_picture || this.userService.defaultAvatarUrl;
    this.personalAvatarSub = this.userService.currentProfilePicture.subscribe((url) => {
      this.personalAvatarUrl = url || this.defaultScopeAvatar;
    });
    this.userService.loadPersonalAvatarUrl().subscribe();
    this.refreshFavoriteScopeAvatars();
    this.langSub = this.locale.currentLocale$.subscribe(() => {
      if (this.navItems.length) {
        this.buildPersonalAppCards();
      }
      this.rebuildTeamAppList();
      this.cdr.markForCheck();
    });
  }

  ngAfterViewInit(): void {
    this.syncImaginusPage(this.router.url);
    // 延後側欄同步，避免 CoreUI 在同一輪 CD 內 emit visibleChange 觸發 NG0100
    setTimeout(() => {
      this.syncDesktopSidebar(true);
      this.sidebarState.queueShellSidebarOffsetSync(this.isMobile);
      this.cdr.markForCheck();
    }, 0);
    this.sidebarState.observeShellSidebarOffset(() => this.isMobile);
    this.imaginusNavSub = this.teamImaginusNav.sessions$.subscribe(() => {
      this.recomputeUnifiedNav();
    });
    this.favoriteAppsSub = this.favoriteAppsService.links$.subscribe((links) => {
      this.favoriteApps = links;
      this.refreshFavoriteScopeAvatars();
    });
    this.previousNavUrl = this.router.url;
    this.imaginusRouteSub = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        const prevUrl = this.previousNavUrl;
        const url = e.urlAfterRedirects;
        this.previousNavUrl = url;
        const remountedFromFullscreen =
          this.isDetachedFullscreenRoute(prevUrl) && !this.isDetachedFullscreenRoute(url);

        this.recomputeUnifiedNav();
        this.syncImaginusPage(url);
        this.syncRouteTeamCode(url);
        this.syncChatNavMode(prevUrl, url);
        this.syncSidebarAfterNavigation(remountedFromFullscreen);
        this.cdr.markForCheck();
      });
    this.refreshUnifiedImaginusFromApi();
    this.sidebarToggleRequestSub = this.sidebarState
      .onSidebarToggleRequest$('individual')
      .subscribe(() => this.toggleSidebar());
    this.selectedTeamPrefSub = this.userPreferencesService.selectedTeamCode$.subscribe((code) => {
      this.syncLauncherTeamFromPreferences(code);
    });
    this.chatConversationsSub = this.chatConversationService.conversations$.subscribe((list) => {
      this.chatConversations = list;
      this.hasChatUnread = this.chatConversationService.hasAnyUnread();
      this.cdr.markForCheck();
    });
    // 由常駐的 shell 啟動輪詢，讓左側聊天室清單在任何頁面都能即時更新。
    this.chatConversationService.startPolling();
  }

  private updateSessionUiHints(): void {
    this.useSessionTouchSheet =
      this.isMobile ||
      (typeof matchMedia !== 'undefined' && matchMedia('(hover: none)').matches);
    this.showSessionMenuDropdown = !this.useSessionTouchSheet;
  }

  ngOnDestroy(): void {
    if (typeof document !== 'undefined') {
      document.body.classList.remove('imaginus-app-shell');
    }
    this.sidebarState.disconnectShellSidebarOffsetObserver();
    this.clearSessionLongPressTimer();
    this.imaginusNavSub?.unsubscribe();
    this.imaginusRouteSub?.unsubscribe();
    this.favoriteAppsSub?.unsubscribe();
    this.personalAvatarSub?.unsubscribe();
    this.sidebarToggleRequestSub?.unsubscribe();
    this.selectedTeamPrefSub?.unsubscribe();
    this.chatConversationsSub?.unsubscribe();
    this.langSub?.unsubscribe();
    this.chatConversationService.stopPolling();
    if (this.createTeamToastTimer) {
      clearTimeout(this.createTeamToastTimer);
    }
  }

  /** 左側 nav 是否切換為聊天室清單模式（純 UI 切換，不一定在 /chats 頁）。 */
  chatNavMode = false;

  private isChatsUrl(url: string): boolean {
    const path = (url || '').split('?')[0].split('#')[0];
    return /^\/team\/[^/]+\/chats/.test(path);
  }

  /** 是否實際停留在統一聊天收件匣頁。 */
  get isChatMode(): boolean {
    return this.isChatsUrl(this.router.url);
  }

  /** 進入聊天室 nav（不換頁，只把左側 nav 切成聊天室清單）。 */
  enterChatNav(): void {
    this.chatNavMode = true;
  }

  /** 返回：把左側 nav 切回原本的應用與 Imaginus 對話（不換頁）。 */
  exitChatNav(): void {
    this.chatNavMode = false;
  }

  /**
   * 依導覽狀態同步 chatNavMode：
   * - 從非聊天頁進入 /chats：自動進入聊天 nav。
   * - 離開 /chats：回到一般 nav。
   * - 在 /chats 內導覽（同頁切換會話）：保留使用者目前的 nav 選擇（尊重「返回」）。
   */
  private syncChatNavMode(prevUrl: string, url: string): void {
    const wasChat = this.isChatsUrl(prevUrl);
    const isChat = this.isChatsUrl(url);
    if (isChat && !wasChat) {
      this.chatNavMode = true;
    } else if (!isChat) {
      this.chatNavMode = false;
    }
  }

  get chatRouteTeamCode(): string {
    const m = this.router.url.match(/\/team\/([^/?#]+)\/chats/i);
    return (
      m?.[1] || this.activeRouteTeamCode || this.team_list[0]?.team_code || ''
    );
  }

  get activeChatConversationKey(): string {
    const path = this.router.url.split('?')[0].split('#')[0];
    const prefix = `/team/${this.chatRouteTeamCode}/chats/`;
    return path.startsWith(prefix) ? decodeURIComponent(path.slice(prefix.length)) : '';
  }

  /**
   * nav 清單只顯示「已有訊息」的會話，並依最新訊息時間排序（新→舊）；
   * 尚無對話的場域不列出（可從「開始聊天」進入）。
   */
  get visibleChatConversations(): ChatConversation[] {
    return this.chatConversations
      .filter((c) => !!c.last_message_at)
      .sort((a, b) =>
        (b.last_message_at || '').localeCompare(a.last_message_at || '')
      );
  }

  isChatConversationActive(conv: ChatConversation): boolean {
    return conv?.conversation_key === this.activeChatConversationKey;
  }

  isChatConversationUnread(conv: ChatConversation): boolean {
    return this.chatConversationService.isUnread(conv);
  }

  trackByConversationKey = (_: number, conv: ChatConversation) =>
    conv?.conversation_key ?? _;

  get defaultScopeAvatar(): string {
    return this.userService.defaultAvatarUrl;
  }

  private syncRouteTeamCode(url: string): void {
    const m = url.match(/\/team\/([^/?#]+)/i);
    this.activeRouteTeamCode = m?.[1] || '';
    const qp = this.router.parseUrl(url).queryParams;
    const ctxTeam = (qp['ctx_team'] as string) || '';
    const queryTeamCode =
      qp['scope'] === 'team' && qp['team_code'] ? String(qp['team_code']) : '';

    if (ctxTeam || queryTeamCode) {
      this.selectedTeamCodeForApps = ctxTeam || queryTeamCode;
      this.userPreferencesService.setSelectedTeamCode(this.selectedTeamCodeForApps);
    }

    if (this.team_list.length) {
      this.ensureLauncherTeamSelectionSynced(true);
    } else if (this.selectedTeamCodeForApps) {
      this.refreshTeamAppsForSelection();
    }
  }

  private resolveSelectedTeamCodeForApps(): string {
    const saved = (this.userPreferencesService.getSelectedTeamCode() || '').trim();
    if (this.activeRouteTeamCode) {
      return this.activeRouteTeamCode;
    }
    // team_list 尚未載入時仍保留偏好，避免被誤清成空／第一個團隊
    if (saved && (!this.team_list.length || this.team_list.some((t) => t.team_code === saved))) {
      return saved;
    }
    return this.team_list[0]?.team_code || '';
  }

  trackTeamByCode(_index: number, t: team): string {
    return t.team_code;
  }

  get hasTeams(): boolean {
    return this.team_list.length > 0;
  }

  get hasPendingTeams(): boolean {
    return this.pending_team_list.length > 0;
  }

  get selectedTeamForApps(): team | undefined {
    return this.team_list.find((t) => t.team_code === this.selectedTeamCodeForApps);
  }

  openPersonalSettings(): void {
    this.appModalVisible = false;
    this.router.navigate(['/settings']);
  }

  /** 群組與應用 modal 文案（走 LocaleService，避免 translate pipe 在 modal 內未刷新） */
  launcherText(key: string): string {
    return this.locale.instant(`layout.launcher.${key}`);
  }

  createTeamText(key: string): string {
    return this.locale.instant(`layout.createTeam.${key}`);
  }

  openTeamSettingsFromLauncher(): void {
    if (!this.selectedTeamCodeForApps) {
      return;
    }
    this.navigateTeamHub('settings');
  }

  onToggleFavoriteClick(
    ev: Event,
    child: AppChild,
    section: 'personal' | 'team',
    appIcon?: string,
  ): void {
    ev.preventDefault();
    ev.stopPropagation();
    this.toggleFavoriteApp(child, section, appIcon);
  }

  navigateTeamHub(segment: string): void {
    const code = this.selectedTeamCodeForApps || this.activeRouteTeamCode;
    if (!code) {
      return;
    }
    this.appModalVisible = false;
    this.router.navigate(['/team', code, segment]);
  }

  private syncImaginusPage(url: string): void {
    let path = url.split('?')[0];
    if (path.includes('#')) {
      path = path.split('#').pop() || path;
    }
    if (!path.startsWith('/')) {
      path = `/${path}`;
    }
    this.isImaginusPage = path === '/home' || path === '/imaginus';
    this.isContentBleed =
      this.isImaginusPage ||
      /^\/team\/[^/]+\/application\/[12]\/places\/[^/]+\/chatroom$/i.test(path) ||
      // 統一聊天室（含場域聊天室）沿用與獨立聊天室相同的全幅 100dvh 外殼與浮動頂欄，
      // 否則手機版 position:fixed 的輸入列會落在瀏覽器底部工具列後方而看不到。
      /^\/team\/[^/]+\/chats/i.test(path);
    if (this.isContentBleed) {
      this.sidebarState.queueShellSidebarOffsetSync(this.isMobile);
    }
    if (typeof document !== 'undefined') {
      document.body.classList.toggle('imaginus-app-shell', this.isContentBleed);
    }
  }

  recomputeUnifiedNav(): void {
    const s = this.teamImaginusNav.getSessionsSnapshot();
    this.imaginusList = this.teamImaginusNav.getOrderedSessions(this.unifiedPinKey, s);
  }

  get displayImaginusList(): ImaginusNavSession[] {
    return this.imaginusList;
  }

  get sidebarToggleAriaLabel(): string {
    if (this.isMobile) {
      return this.sidebarVisible
        ? this.locale.instant('sidebar.toggle_close_menu')
        : this.locale.instant('sidebar.toggle_open_menu');
    }
    return this.sidebarUnfoldable
      ? this.locale.instant('sidebar.toggle_expand')
      : this.locale.instant('sidebar.toggle_collapse');
  }

  sessionNavKey(session: ImaginusNavSession): string {
    return imaginusSessionNavKey(session);
  }

  sessionQueryParams(session: ImaginusNavSession): Record<string, string> {
    return imaginusSessionQueryParams(session);
  }

  private refreshUnifiedImaginusFromApi(): void {
    this.imaginusService.get_unified_sessions().subscribe({
      next: (data) => {
        const list: ImaginusNavSession[] = (data?.sessions || []).map((x: Record<string, unknown>) => ({
          id: String(x['id'] || ''),
          name: String(x['name'] || '對話'),
          scope: (x['scope'] === 'team' ? 'team' : 'individual') as ImaginusNavSession['scope'],
          team_code: x['team_code'] ? String(x['team_code']) : undefined,
          team_name: x['team_name'] ? String(x['team_name']) : undefined,
          last_message_at: x['last_message_at'] ? String(x['last_message_at']) : undefined,
        })).filter((s) => s.id);
        const qp = this.router.parseUrl(this.router.url).queryParams;
        const sid = (qp['session'] as string) || '';
        if (sid && !list.some((r) => r.id === sid)) {
          const snap = this.teamImaginusNav.getSessionsSnapshot().find((s) => s.id === sid);
          if (snap) {
            list.unshift(snap);
          }
        }
        this.teamImaginusNav.setSessions(list);
        this.recomputeUnifiedNav();
      },
      error: () => {
        this.imaginusService.get_anonymous_sessions().subscribe({
          next: (fallback) => {
            const list = (fallback?.sessions || []).map((x: { id: string; name?: string }) => ({
              id: x.id,
              name: x.name || '對話',
              scope: 'individual' as const,
            }));
            this.teamImaginusNav.setSessions(list);
            this.recomputeUnifiedNav();
          },
        });
      },
    });
  }

  isNewDialogActive(): boolean {
    const path = this.router.url.split('?')[0];
    if (path !== '/home' && path !== '/imaginus') {
      return false;
    }
    return !this.router.parseUrl(this.router.url).queryParams['session'];
  }

  isSessionQueryActive(session: ImaginusNavSession): boolean {
    const qp = this.router.parseUrl(this.router.url).queryParams;
    if ((qp['session'] || '') !== session.id) {
      return false;
    }
    const scope = (qp['scope'] as string) || 'individual';
    if (session.scope === 'team') {
      return scope === 'team' && (qp['team_code'] || '') === (session.team_code || '');
    }
    return scope !== 'team';
  }

  onSessionMenuPin(s: ImaginusNavSession, ev: Event): void {
    ev.stopPropagation();
    this.teamImaginusNav.togglePin(this.unifiedPinKey, imaginusSessionNavKey(s));
    this.recomputeUnifiedNav();
  }

  onSessionMenuRename(s: ImaginusNavSession, ev: Event): void {
    ev.stopPropagation();
    this.teamImaginusNav.requestRenameSession(s, this.router);
  }

  onSessionMenuDelete(s: ImaginusNavSession, ev: Event): void {
    ev.stopPropagation();
    this.teamImaginusNav.requestDeleteSession(s, this.router);
  }

  rebuildTeamAppList(): void {
    if (!this.teamAppsActivatedIds.length) {
      return;
    }
    this.teamAppList = this.teamAppsCatalogTemplate
      .filter((app) => this.teamAppsActivatedIds.includes(app.id))
      .map((app) => ({
        id: app.id,
        name: this.locale.instant(app.nameKey),
        description: this.locale.instant(app.descKey),
        url: app.url,
        icon: app.icon,
        children: app.children.map((child) => ({
          name: this.locale.instant(child.nameKey),
          url: child.url,
        })),
      }));
    this.cdr.markForCheck();
  }

  sessionLabel(name: string): string {
    const trimmed = (name || '').trim();
    if (!trimmed) {
      return this.locale.instant('layout.chat.defaultName');
    }
    const newDefault = this.locale.instant('layout.chat.newChatDefault');
    const newAlt = this.locale.instant('layout.chat.newChatAlt');
    if (trimmed === '新對話' || trimmed === '新交談' || trimmed === newDefault || trimmed === newAlt) {
      return this.locale.instant('layout.chat.defaultName');
    }
    return trimmed;
  }

  favoriteScopeLabel(fav: FavoriteAppLink): string | null {
    if (fav.section === 'team') {
      if (fav.team_name) {
        return fav.team_name;
      }
      if (fav.team_code) {
        const team = this.team_list.find((t) => t.team_code === fav.team_code);
        if (team?.team_name) {
          return team.team_name;
        }
      }
      return fav.team_code || this.locale.instant('layout.scope.team');
    }
    return this.locale.instant('layout.scope.personal');
  }

  favoriteLinkTitle(fav: FavoriteAppLink): string {
    const scope = this.favoriteScopeLabel(fav);
    return scope ? `${fav.label}（${scope}）` : fav.label;
  }

  favoriteScopeAvatarUrl(fav: FavoriteAppLink): string {
    if (fav.section === 'team' && fav.team_code) {
      return this.teamAvatarUrls[fav.team_code] || this.defaultScopeAvatar;
    }
    return (
      this.personalAvatarUrl ||
      this.userService.profile_picture ||
      this.defaultScopeAvatar
    );
  }

  onFavoriteScopeAvatarError(event: Event, fav: FavoriteAppLink): void {
    const img = event.target as HTMLImageElement | null;
    if (!img || img.dataset['avatarFallback'] === '1') {
      return;
    }
    img.dataset['avatarFallback'] = '1';
    img.src = this.defaultScopeAvatar;
    if (fav.section === 'team' && fav.team_code) {
      this.teamAvatarUrls = { ...this.teamAvatarUrls, [fav.team_code]: this.defaultScopeAvatar };
      return;
    }
    this.userService.loadPersonalAvatarUrl(true).subscribe({
      next: (url) => {
        this.personalAvatarUrl = url || this.defaultScopeAvatar;
        if (img.isConnected) {
          img.dataset['avatarFallback'] = '0';
          img.src = this.personalAvatarUrl;
        }
      },
    });
  }

  private refreshFavoriteScopeAvatars(): void {
    const hasPersonalFavorite = this.favoriteApps.some((f) => f.section !== 'team');
    if (hasPersonalFavorite) {
      const cached = this.userService.profile_picture;
      if (cached) {
        this.personalAvatarUrl = cached;
      } else {
        this.userService.loadPersonalAvatarUrl().subscribe();
      }
    }

    const codes = new Set(
      this.favoriteApps
        .filter((f) => f.section === 'team' && f.team_code)
        .map((f) => String(f.team_code)),
    );
    codes.forEach((code) => {
      if (this.teamAvatarUrls[code]) {
        return;
      }
      this.teamService.loadTeamAvatarUrl(code).subscribe({
        next: (url) => {
          this.teamAvatarUrls = { ...this.teamAvatarUrls, [code]: url || this.defaultScopeAvatar };
        },
        error: () => {
          this.teamAvatarUrls = { ...this.teamAvatarUrls, [code]: this.defaultScopeAvatar };
        },
      });
    });
  }

  onSessionLinkClick(ev: Event, _s: ImaginusNavSession): void {
    if (this.suppressNextSessionLink) {
      this.suppressNextSessionLink = false;
      ev.preventDefault();
      ev.stopPropagation();
    }
  }

  onSessionRowTouchStart(s: ImaginusNavSession, e: TouchEvent): void {
    if (!this.useSessionTouchSheet) {
      return;
    }
    if (e.touches && e.touches.length > 1) {
      return;
    }
    this.clearSessionLongPressTimer();
    this.sessionLpt = setTimeout(() => {
      this.sessionLpt = null;
      this.suppressNextSessionLink = true;
      this.sessionActionTarget = s;
      this.sessionActionSheetOpen = true;
    }, 480);
  }

  onSessionRowTouchEnd(_e: Event): void {
    this.clearSessionLongPressTimer();
  }

  onSessionRowTouchMove(_e: TouchEvent): void {
    this.clearSessionLongPressTimer();
  }

  private clearSessionLongPressTimer(): void {
    if (this.sessionLpt) {
      clearTimeout(this.sessionLpt);
      this.sessionLpt = null;
    }
  }

  onSessionActionSheetVisible(visible: boolean): void {
    this.sessionActionSheetOpen = visible;
    if (!visible) {
      this.sessionActionTarget = null;
    }
  }

  closeSessionActionSheet(): void {
    this.sessionActionSheetOpen = false;
    this.sessionActionTarget = null;
  }

  onSessionActionSheetPin(t: ImaginusNavSession): void {
    this.onSessionMenuPin(t, new Event('click'));
    this.closeSessionActionSheet();
  }

  onSessionActionSheetRename(t: ImaginusNavSession): void {
    this.onSessionMenuRename(t, new Event('click'));
    this.closeSessionActionSheet();
  }

  onSessionActionSheetDelete(t: ImaginusNavSession): void {
    this.onSessionMenuDelete(t, new Event('click'));
    this.closeSessionActionSheet();
  }

  get_self_info() {
    this.userService.get_self_info().subscribe(
      (data) => {
        this.user = data.user;
        this.userPreferencesService.applyFromUser(data.user);
        if (data.user?.email) {
          this.chatConversationService.setCurrentEmail(data.user.email);
        }
        this.syncRouteTeamCode(this.router.url);
        TokenStorageService.refreshToken(data.token);
        this.filterNavItems();
        this.buildPersonalAppCards();
      },
      () => {
        this.router.navigate(['404']);
      }
    );
  }

  loadUserTeams(): void {
    this.groupService.get_user_team().subscribe({
      next: (data) => {
        if (data?.token) {
          TokenStorageService.refreshToken(data.token);
        }
        this.team_list = (data?.teams || []).filter((t: team) => !t.disabled);
        this.pending_team_list = (data?.pending_teams || []).map((t: team) => ({
          team_code: t.team_code,
          team_name: t.team_name,
          accounts: [],
        }));
        this.ensureLauncherTeamSelectionSynced(true);
        this.remountTeamAppsSelect();
        this.cdr.markForCheck();
      },
    });
  }

  /** option 重建後強制 select 顯示與 selectedTeamCodeForApps 一致 */
  private remountTeamAppsSelect(): void {
    if (!this.team_list.length) {
      return;
    }
    const code = this.selectedTeamCodeForApps;
    this.teamAppsSelectMounted = false;
    this.cdr.detectChanges();
    this.selectedTeamCodeForApps = code;
    this.teamAppsSelectMounted = true;
    this.cdr.detectChanges();
  }

  onTeamAppsSelectionChange(): void {
    this.teamAppList = [];
    this.teamAppsLoadedForCode = '';
    this.userPreferencesService.setSelectedTeamCode(this.selectedTeamCodeForApps);
    this.refreshTeamAppsForSelection();
  }

  refreshTeamAppsForSelection(): void {
    const code = this.selectedTeamCodeForApps;
    if (!code) {
      this.teamAppList = [];
      this.teamAppsLoadedForCode = '';
      return;
    }
    const seq = ++this.teamAppsFetchSeq;
    this.teamService.get_team_info(code).subscribe({
      next: (data) => {
        if (seq !== this.teamAppsFetchSeq || code !== this.selectedTeamCodeForApps) {
          return;
        }
        if (data?.token) {
          TokenStorageService.refreshToken(data.token);
        }
        const activated = data?.data?.activated_applications || [];
        this.teamAppsActivatedIds = activated.map((a: { appId: number }) => a.appId);
        this.rebuildTeamAppList();
        this.teamAppsLoadedForCode = code;
        this.cdr.markForCheck();
      },
      error: () => {
        if (seq !== this.teamAppsFetchSeq || code !== this.selectedTeamCodeForApps) {
          return;
        }
        this.teamAppList = [];
        this.teamAppsLoadedForCode = '';
        this.cdr.markForCheck();
      },
    });
  }

  /** 路由上的團隊優先；其餘依偏好與 Imaginus ctx_team */
  private syncLauncherTeamSelection(forceRefreshApps = true): void {
    this.ensureLauncherTeamSelectionSynced(forceRefreshApps);
  }

  private resolveLauncherTeamCode(): string {
    const qp = this.router.parseUrl(this.router.url).queryParams;
    const ctxTeam = (qp['ctx_team'] as string) || '';
    const queryTeamCode =
      qp['scope'] === 'team' && qp['team_code'] ? String(qp['team_code']) : '';

    return (
      this.activeRouteTeamCode ||
      ctxTeam ||
      queryTeamCode ||
      this.resolveSelectedTeamCodeForApps()
    );
  }

  /** 讓下拉選單與 teamAppList 永遠對應同一個 team_code */
  private ensureLauncherTeamSelectionSynced(forceRefreshApps: boolean): void {
    const preferred = this.resolveLauncherTeamCode();
    if (!preferred && !this.team_list.length) {
      this.selectedTeamCodeForApps = '';
      this.teamAppList = [];
      this.teamAppsLoadedForCode = '';
      return;
    }

    let next = preferred;
    if (this.team_list.length) {
      const inList = this.team_list.some((t) => t.team_code === next);
      if (!inList) {
        next = this.team_list[0]?.team_code || next;
      }
    }

    if (!next) {
      return;
    }

    const selectionChanged = next !== this.selectedTeamCodeForApps;
    if (selectionChanged) {
      this.selectedTeamCodeForApps = next;
      this.userPreferencesService.setSelectedTeamCode(next);
      this.teamAppList = [];
      this.teamAppsLoadedForCode = '';
      forceRefreshApps = true;
    }

    if (forceRefreshApps || this.teamAppsLoadedForCode !== this.selectedTeamCodeForApps) {
      this.refreshTeamAppsForSelection();
    }
  }

  private syncLauncherTeamFromPreferences(code: string): void {
    if (this.activeRouteTeamCode) {
      return;
    }
    const trimmed = (code || '').trim();
    if (!trimmed || trimmed === this.selectedTeamCodeForApps) {
      if (this.appModalVisible && this.teamAppsLoadedForCode !== this.selectedTeamCodeForApps) {
        this.refreshTeamAppsForSelection();
      }
      return;
    }
    this.selectedTeamCodeForApps = trimmed;
    this.teamAppList = [];
    this.teamAppsLoadedForCode = '';
    if (this.appModalVisible || this.team_list.length) {
      this.ensureLauncherTeamSelectionSynced(true);
    }
  }

  filterNavItems() {
    this.navItems = [...navItems]
      .filter(item => {
        if (item.roles && !this.isRoleAllowed(item)) return false;
        if (item.appId !== undefined && item.appId !== null) {
          return this.user?.activated_applications?.some(a => a.appId === item.appId);
        }
        return true;
      })
      .map(item => {
        if (Array.isArray(item.children)) {
          item.children = item.children.filter(child => {
            if (child.roles && !this.isRoleAllowed(child)) return false;
            if (child.appId !== undefined && child.appId !== null) {
              return this.user?.activated_applications?.some(a => a.appId === child.appId);
            }
            return true;
          });
        }
        return item;
      });
  }

  buildPersonalAppCards() {
    this.personalAppList = [];
    this.personalAppLinks = [];
    let deviceChildren: AppChild[] = [];
    let adminChildren: AppChild[] = [];
    const deviceNavIds = new Set(['device_live', 'device_history', 'lan_installer', 'documents']);
    const skipNavIds = new Set(['groups', 'settings', 'tasks']);

    this.navItems.forEach(item => {
      if (item.name === 'IMAGINUS' || item.title) return;
      if (item.navId && skipNavIds.has(item.navId)) return;

      const child: AppChild = { name: this.navLabel(item), url: item.url as string };

      if (item.navId && deviceNavIds.has(item.navId)) {
        deviceChildren.push({ ...child, icon: item.iconComponent?.name || 'cilCompass' });
      } else if (item.navId === 'admin') {
        item.children?.forEach(c =>
          adminChildren.push({ name: this.navLabel(c), url: c.url as string, icon: 'cilSettings' }),
        );
      }
    });

    this.personalAppLinks = [...adminChildren, ...deviceChildren];

    if (adminChildren.length > 0) {
      this.personalAppList.push({
        id: 102,
        name: this.locale.instant('nav.system_admin'),
        description: this.locale.instant('nav.system_admin_desc'),
        url: '',
        icon: 'cilSettings',
        children: adminChildren,
      });
    }
    if (deviceChildren.length > 0) {
      this.personalAppList.push({
        id: 103,
        name: this.locale.instant('nav.device_monitor'),
        description: this.locale.instant('nav.device_monitor_desc'),
        url: '',
        icon: 'cilCompass',
        children: deviceChildren,
      });
    }
  }

  navLabel(item: { nameKey?: string; name?: string }): string {
    if (item.nameKey) {
      return this.locale.instant(item.nameKey);
    }
    return item.name || '';
  }

  isRoleAllowed(item: any): boolean {
    if (!item.roles || !Array.isArray(item.roles)) return false;
    return item.roles.some((role: string) => this.user.role.includes(role));
  }

  isFavoriteUrl(url: string): boolean {
    return this.favoriteAppsService.isFavorite(this.resolveAppUrl(url));
  }

  toggleFavoriteApp(child: AppChild, section: 'personal' | 'team', appIcon?: string): void {
    const url = this.resolveAppUrl(child.url);
    const team = this.team_list.find((t) => t.team_code === this.selectedTeamCodeForApps);
    this.favoriteAppsService.toggle({
      label: child.name,
      url,
      icon: appIcon || 'cilApps',
      section,
      team_code: section === 'team' ? this.selectedTeamCodeForApps : undefined,
      team_name: section === 'team' ? team?.team_name : undefined,
    });
  }

  removeFavoriteApp(link: FavoriteAppLink, ev: Event): void {
    ev.preventDefault();
    ev.stopPropagation();
    this.favoriteAppsService.remove(link.id);
  }

  isFavoriteLinkActive(link: FavoriteAppLink): boolean {
    // 只高亮「最長前綴匹配」的常用連結，確保同一時間至多只有一個（最精確的）亮起。
    // 例如進入場域內頁 .../places/{id}（或其子頁）時，只亮「場域內容」，
    // 不會因前綴相同而把「我的場域」.../places 也一起標記為使用中。
    const currentPath = this.router.url.split('?')[0].split('#')[0];
    const linkPath = (link.url || '').split('?')[0].split('#')[0];
    if (!linkPath || !this.isPathPrefixMatch(currentPath, linkPath)) {
      return false;
    }
    const bestLen = this.favoriteApps.reduce((max, fav) => {
      const favPath = (fav.url || '').split('?')[0].split('#')[0];
      return favPath && this.isPathPrefixMatch(currentPath, favPath)
        ? Math.max(max, favPath.length)
        : max;
    }, 0);
    return linkPath.length === bestLen;
  }

  /** 以「路徑分段」為界判斷 linkPath 是否為 currentPath 的前綴（或完全相同）。 */
  private isPathPrefixMatch(currentPath: string, linkPath: string): boolean {
    return currentPath === linkPath || currentPath.startsWith(`${linkPath}/`);
  }

  openCreateTeamModal(): void {
    this.showInlineJoinTeam = false;
    this.joinTeamCode = '';
    this.newTeamName = '';
    this.showInlineCreateTeam = true;
    this.cdr.markForCheck();
  }

  openJoinTeamModal(): void {
    this.showInlineCreateTeam = false;
    this.newTeamName = '';
    this.joinTeamCode = '';
    this.showInlineJoinTeam = true;
    this.cdr.markForCheck();
  }

  closeCreateTeamModal(): void {
    this.closeTeamFormPanels();
  }

  closeTeamFormPanels(): void {
    this.showInlineCreateTeam = false;
    this.showInlineJoinTeam = false;
    this.newTeamName = '';
    this.joinTeamCode = '';
    this.cdr.markForCheck();
  }

  private purgeModalBackdrops(): void {
    if (typeof document === 'undefined') {
      return;
    }
    document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());
  }

  private purgeModalBodyIfIdle(): void {
    if (typeof document === 'undefined') {
      return;
    }
    if (this.appModalVisible) {
      return;
    }
    document.body.classList.remove('modal-open');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
    this.purgeModalBackdrops();
  }

  // CoreUI 關閉 modal 有約 150ms 淡出動畫，期間仍會操作 backdrop / body class。
  // 清理必須等動畫結束後才執行，否則會清到一半被 CoreUI 重新加回，留下卡住的灰色 backdrop。
  private readonly MODAL_TRANSITION_MS = 220;
  private scheduleModalCleanup(): void {
    setTimeout(() => this.purgeModalBodyIfIdle(), this.MODAL_TRANSITION_MS + 120);
  }

  submitCreateTeam(): void {
    const name = this.newTeamName.trim();
    if (!name || this.isCreatingTeam) {
      return;
    }
    this.isCreatingTeam = true;
    this.groupService.create_team(name).subscribe({
      next: (data) => {
        this.isCreatingTeam = false;
        if (data?.token) {
          TokenStorageService.refreshToken(data.token);
        }
        this.closeTeamFormPanels();
        this.loadUserTeams();
        this.showCreateTeamToast(
          this.locale.instant('layout.createTeam.success', { name }),
        );
      },
      error: () => {
        this.isCreatingTeam = false;
      },
    });
  }

  submitJoinTeam(): void {
    const code = this.joinTeamCode.trim();
    if (!code || this.isApplyingJoinTeam) {
      return;
    }
    this.isApplyingJoinTeam = true;
    this.groupService.search_team_code(code).subscribe({
      next: (data) => {
        this.isApplyingJoinTeam = false;
        if (data?.token) {
          TokenStorageService.refreshToken(data.token);
        }
        const teamName = data?.team_name || code;
        const confirmed = confirm(
          this.locale.instant('layout.launcher.joinTeamConfirm', { name: teamName }),
        );
        if (!confirmed) {
          return;
        }
        this.confirmApplyJoinTeam(code);
      },
      error: (error) => {
        this.isApplyingJoinTeam = false;
        const errCode = error?.error?.code;
        const msg =
          errCode === 'team_not_found'
            ? this.locale.instant('layout.launcher.joinTeamNotFound')
            : error?.error?.message ||
              error?.error?.msg ||
              this.locale.instant('layout.launcher.joinTeamFailed');
        alert(msg);
      },
    });
  }

  private confirmApplyJoinTeam(code: string): void {
    if (this.isApplyingJoinTeam) {
      return;
    }
    this.isApplyingJoinTeam = true;
    this.groupService.apply_entering_team(code).subscribe({
      next: (data) => {
        this.isApplyingJoinTeam = false;
        if (data?.token) {
          TokenStorageService.refreshToken(data.token);
        }
        this.closeTeamFormPanels();
        this.loadUserTeams();
        this.showCreateTeamToast(this.locale.instant('layout.launcher.joinTeamSuccess'));
      },
      error: (error) => {
        this.isApplyingJoinTeam = false;
        const msg =
          error?.error?.message ||
          error?.error?.msg ||
          this.locale.instant('layout.launcher.joinTeamFailed');
        alert(msg);
      },
    });
  }

  private showCreateTeamToast(message: string): void {
    this.createTeamToast = message;
    if (this.createTeamToastTimer) {
      clearTimeout(this.createTeamToastTimer);
    }
    this.createTeamToastTimer = setTimeout(() => {
      this.createTeamToast = null;
      this.createTeamToastTimer = null;
      this.cdr.markForCheck();
    }, 3000);
    this.cdr.markForCheck();
  }

  @HostListener('window:resize')
  onResize(): void {
    this.checkMobile();
  }

  private checkMobile(): void {
    const wasMobile = this.isMobile;
    this.isMobile = window.innerWidth <= APP_SHELL_MOBILE_MAX_WIDTH;
    if (this.isMobile !== wasMobile) {
      this.sidebarUnfoldable = false;
      this.sidebarVisible = !this.isMobile;
      this.sidebarState.setSidebarState('individual', this.sidebarVisible);
      if (!this.isMobile) {
        this.syncDesktopSidebar(true);
      }
      this.sidebarState.queueShellSidebarOffsetSync(this.isMobile);
      this.updateSessionUiHints();
      this.cdr.markForCheck();
      return;
    }
    if (!this.isMobile) {
      this.syncDesktopSidebar(true);
    }
    this.sidebarState.queueShellSidebarOffsetSync(this.isMobile);
    this.updateSessionUiHints();
  }

  private isDetachedFullscreenRoute(url: string): boolean {
    const path = (url || '').split('?')[0];
    return /\/plot-(?:edit|view)\/[^/?#]+/.test(path)
      || /\/device-dashboard-(?:edit|view)\//.test(path);
  }

  /** plot-edit 等全螢幕子頁返回 layout 時，重設 CoreUI 側欄狀態 */
  private syncSidebarAfterNavigation(fromFullscreen = false): void {
    if (!this.isMobile) {
      this.syncDesktopSidebar(true);
      if (fromFullscreen) {
        setTimeout(() => this.syncDesktopSidebar(true), 50);
      }
      return;
    }

    this.sidebarVisible = false;
    this.sidebarState.setSidebarState('individual', false);
    if (fromFullscreen) {
      this.sidebarState.repairDesktopSidebarShell(this.sidebarRef, { visible: false });
    }
  }

  /** CoreUI 在 viewport 切換或從全螢幕子頁（plot-edit）返回時可能把側欄設為 hide，需重設 visible 綁定 */
  private syncDesktopSidebar(force = false): void {
    if (this.isMobile) {
      return;
    }
    if (force || !this.sidebarVisible) {
      this.sidebarVisible = true;
      this.sidebarState.setSidebarState('individual', true);
    }
    this.sidebarState.repairDesktopSidebarShell(this.sidebarRef, {
      narrow: this.sidebarUnfoldable,
      visible: true,
    });
    this.sidebarState.queueShellSidebarOffsetSync(this.isMobile);
    this.cdr.markForCheck();
  }

  toggleSidebar(): void {
    if (this.isMobile) {
      this.sidebarVisible = !this.sidebarVisible;
      this.sidebarState.setSidebarState('individual', this.sidebarVisible);
    } else {
      this.sidebarUnfoldable = !this.sidebarUnfoldable;
      this.syncDesktopSidebar(true);
    }
    this.sidebarState.queueShellSidebarOffsetSync(this.isMobile);
  }

  hideSidebar(): void {
    if (this.isMobile) {
      this.sidebarVisible = false;
      this.sidebarState.setSidebarState('individual', false);
      this.sidebarState.queueShellSidebarOffsetSync(this.isMobile);
    }
  }

  onVisibleChange(event: boolean): void {
    if (!this.isMobile) {
      if (!event || !this.sidebarVisible) {
        // 延後，避免與 CoreUI 同輪 CD 衝突（NG0100 false→true）
        setTimeout(() => {
          this.syncDesktopSidebar(true);
          this.cdr.markForCheck();
        }, 0);
      }
      return;
    }
    if (event === this.sidebarVisible) {
      return;
    }
    setTimeout(() => {
      this.sidebarVisible = event;
      this.sidebarState.setSidebarState('individual', event);
      this.sidebarState.queueShellSidebarOffsetSync(this.isMobile);
      this.cdr.markForCheck();
    }, 0);
  }

  onAppModalVisibleChange(visible: boolean): void {
    if (visible === this.appModalVisible) {
      return;
    }
    setTimeout(() => {
      this.appModalVisible = visible;
      if (visible) {
        this.buildPersonalAppCards();
        this.syncLauncherTeamSelection(true);
        this.loadUserTeams();
      } else {
        this.closeTeamFormPanels();
        this.scheduleModalCleanup();
      }
      this.cdr.markForCheck();
    }, 0);
  }

  openAppModal() {
    this.buildPersonalAppCards();
    this.syncLauncherTeamSelection(true);
    this.appModalVisible = true;
    this.loadUserTeams();
    this.cdr.markForCheck();
  }

  resolveAppUrl(url: string): string {
    const code = this.selectedTeamCodeForApps || this.activeRouteTeamCode;
    return (url || '').replace(/:team_code/g, code);
  }

  navigateToLink(url: string) {
    this.appModalVisible = false;
    if (this.isMobile) {
      this.sidebarVisible = false;
      this.sidebarState.setSidebarState('individual', false);
    }
    if (typeof document !== 'undefined') {
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('overflow');
      document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());
    }
    const resolved = this.resolveAppUrl(url);
    const [path, query = ''] = resolved.split('?');
    const queryParams: Record<string, string> = {};
    const search = new URLSearchParams(query);
    search.forEach((value, key) => {
      queryParams[key] = value;
    });
    this.router.navigate([path], { queryParams });
  }

  navigateFavoriteLink(link: FavoriteAppLink): void {
    if (this.isMobile) {
      this.sidebarVisible = false;
      this.sidebarState.setSidebarState('individual', false);
    }
    this.router.navigateByUrl(link.url);
  }

  /** 點側欄常用項目右側星星按鈕（或縮合模式右鍵）→ 取消釘選 */
  onUnpinFavoriteClick(ev: Event, fav: FavoriteAppLink): void {
    ev.preventDefault();
    ev.stopPropagation();
    if (!fav?.id) return;
    const confirmed = window.confirm(
      this.locale.instant('layout.chat.unpinConfirm', { label: fav.label }),
    );
    if (!confirmed) return;
    this.favoriteAppsService.remove(fav.id);
  }

  get imaHomeQueryParams(): { new?: string } {
    let path = this.router.url.split('?')[0];
    if (path.includes('#')) {
      path = path.split('#').pop() || path;
    }
    if (!path.startsWith('/')) {
      path = `/${path}`;
    }
    return path === '/home' || path === '/imaginus' ? { new: '1' } : {};
  }
}
